export * from '@fhs/routing/src/routes/v2/menu';
export { default } from '@fhs/routing/src/routes/v2/menu';
